
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5xRci", function(module, exports) {

$parcel$export(module.exports, "default", () => $f79a00f85ab2e126$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eUDtA = parcelRequire("eUDtA");

var $ffCOo = parcelRequire("ffCOo");

var $dh538 = parcelRequire("dh538");

var $4wbMW = parcelRequire("4wbMW");
var $f79a00f85ab2e126$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $gwFzn.memo)(function Status(props) {
    const { text: text, color: color, localId: localId } = props;
    const inlineAnnotationProps = (0, $4wbMW.useInlineAnnotationProps)(props);
    if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...inlineAnnotationProps,
        role: (0, $dh538.fg)('editor_a11y_status_renderer_description') ? 'emphasis' : undefined,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.FabricElementsAnalyticsContext), {
            data: {
                userContext: 'document'
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eUDtA.Status), {
                text: text,
                color: color,
                localId: localId,
                role: (0, $dh538.fg)('editor_a11y_status_renderer_description') ? undefined : 'presentation',
                isBold: (0, $dh538.fg)('platform-component-visual-refresh')
            })
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.FabricElementsAnalyticsContext), {
        data: {
            userContext: 'document'
        },
        children: (0, $dh538.fg)('editor_a11y_status_renderer_description') ? /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            role: "emphasis",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eUDtA.Status), {
                text: text,
                color: color,
                localId: localId,
                isBold: (0, $dh538.fg)('platform-component-visual-refresh')
            })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eUDtA.Status), {
            text: text,
            color: color,
            localId: localId,
            role: "presentation",
            isBold: (0, $dh538.fg)('platform-component-visual-refresh')
        })
    });
});

});


//# sourceMappingURL=status.b1930d90.js.map
